export default Object.freeze({
  items: [],
  isLoading: true,
});
